"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodEligibleForFees = void 0;
const cardType_1 = require("../cardType");
/**
 * Note: Only Credit cards are eligible for fees
 * @param cardType
 * @returns
 */
function PaymentMethodEligibleForFees(cardType) {
    return cardType === cardType_1.CardType.Credit;
}
exports.PaymentMethodEligibleForFees = PaymentMethodEligibleForFees;
//# sourceMappingURL=PaymentMethodEligibleForFees.js.map